import React, { memo } from 'react';

import styles from './Circle.css';

interface IProps {
    radius: number;
    stroke: number;
    progress: number;
    className?: string;
}

export const Circle = memo(({ radius, stroke, progress, className = '' }: IProps) => {
    const normalizedRadius = radius - stroke;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <svg height={radius * 2} width={radius * 2} className={className}>
            <circle
                className={styles.circle}
                fill="transparent"
                strokeWidth={stroke}
                strokeDasharray={`${circumference} ${circumference}`}
                style={{ strokeDashoffset }}
                r={normalizedRadius}
                cx={radius}
                cy={radius}
            />
        </svg>
    );
});
